export default __webpack_public_path__ + "static/media/ICON6.9fc74909.svg";